import React from 'react';
import PropTypes from 'prop-types';
import { getHubCSVFilePath } from 'utilities/index.js';
import { Table, TableBody, TableCell } from 'react-magma-dom';
import { SOURCE, VAR_DETAILS, TEACHING_TAG, DOWNLOAD } from './Constants';

const HiddenColumns = props => {
  const { item, cols } = props;
  return (
    <Table testId="hiddenTable-details">
      <TableBody>
        {cols.map(col => {
          const colValue = item[col];
          let valueUI = null;
          let colUI = col;
          switch (col) {
            case SOURCE: {
              const sourceArray = colValue.split('|');
              const n = sourceArray.length;
              valueUI = sourceArray.map((source, i) => {
                const isLink = source.includes('http://') || source.includes('https://');
                return (
                  <div key={source}>
                    { isLink
                      ? <a href={source} target="_blank" rel="noreferrer">{source}</a>
                      : <p>{source}</p>
                    }
                    {n - i > 1 && <span>|</span>}
                  </div>);
              }
              );
            }
              break;
            case VAR_DETAILS:
              colUI = 'Variable details';
              valueUI = colValue;
              break;
            case TEACHING_TAG: {
              const interestTagValue = item.interest_tag;
              valueUI = `${colValue} , ${interestTagValue}`;
              colUI = 'tags';
            }
              break;
            case DOWNLOAD:
              valueUI = <a href={getHubCSVFilePath(colValue)} className="text-capitalize" >{col}</a>;
              break;
            default:
              break;
          }
          return (
            <tr key={col} className="flex">
              <th className="min-width-150 text-capitalize">
                {colUI}:
              </th>
              <TableCell className="p-0">
                {valueUI}
              </TableCell>
            </tr>
          );
        })}
      </TableBody>
    </Table>
  );
};

HiddenColumns.propTypes = {
  item: PropTypes.object.isRequired,
  cols: PropTypes.array.isRequired
};

export default HiddenColumns;
